import { API_ROUTES } from 'core/api'

export type SurveyParticipantsType = 'pulse'

type ParticipantRouteKey = keyof typeof API_ROUTES

export const participantRoutes: Record<
  SurveyParticipantsType,
  {
    uninvited: ParticipantRouteKey
    invited: ParticipantRouteKey
    add: ParticipantRouteKey
    remove: ParticipantRouteKey
  }
> = {
  pulse: {
    uninvited: 'pulseSurveyUninvitedUsers',
    invited: 'pulseSurveyInvitedUsers',
    add: 'pulseSurveyAddParticipants',
    remove: 'pulseSurveyRemoveParticipants',
  },
}
